import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { logodarkimg, userIcon } from "../../assets/images";
import { Dropdown } from "react-bootstrap";
import "./Header.scss";
import useUser from "../../hooks/useUser";
import {
  crown_subscription,
  delete_transaction,
  logouticons,
  profiledrop,
} from "../../assets/icons";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTimes } from "react-icons/fa";
import LogoutModal from "../modal/LogoutModal";

const Header = () => {
  const { user, isLoggedIn, logout } = useUser();
  const [logoutModal, setLogoutModal] = useState(false);
  const location = useLocation();
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    if (mobileMenu) {
      document.body.classList.add("mobile_open");
    } else {
      document.body.classList.remove("mobile_open");
    }
  }, [mobileMenu]);

  useEffect(() => {
    const allNavItems = document.querySelectorAll("a.nav-item");
    const allDropItems = document.querySelectorAll("a.dropdown-item");
    allNavItems?.forEach((item) => {
      item.addEventListener("click", () => {
        setMobileMenu(false);
      });
    });
    allDropItems?.forEach((item) => {
      item.addEventListener("click", () => {
        setMobileMenu(false);
      });
      // console.log(item.onClick)
    });
  }, [mobileMenu]);

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.focus();
        }, 100);
      }
    }
  });
  // sticky header in scroll function
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    if (window.scrollY > 100) {
      header?.classList?.add("sticky");
    } else {
      header?.classList?.remove("sticky");
    }
  });

  return (
    <header className="header">
      <div className="container">
        <div className="header_content">
          <div className="logo">
            <Link to="/">
              <img src={logodarkimg} alt="Holypills" />
            </Link>
          </div>
          <nav className="header_nav">
            <ul>
              <li>
                <Link to="/about-us" className="nav-item">
                  Why Us
                </Link>
              </li>
              <li>
                <Dropdown className="custom_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <span className="nav-item">Women Health</span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/pcos-symptoms-causes-treatment">
                      PCOS
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/endometriosis-symptoms-causes-treatment">
                      Endometriosis
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/menopause-symptoms-causes-treatment">
                      Menopause
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/postpartum-symptoms-causes-treatment">
                      Postpartum
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              <li>
                <Link to="/healthplan" className="nav-item">
                  Health Plans
                </Link>
              </li>
              <li>
                <Dropdown className="custom_dropdown">
                  <Dropdown.Toggle id="dropdown-basic">
                    <Link to="/doctors/" className="nav-item">Our Experts</Link>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/doctors/homeopathic-doctors-online">
                      Homeopathic Doctors
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/doctors/consult-with-nutritionist-online">
                      Nutritionist
                    </Dropdown.Item>
                    <Dropdown.Item as={Link} to="/doctors/fitness-expert-online">
                      Fitness Coach
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </li>
              <li>
                <a href="https://holypills.in/blog/" className="nav-item">
                  Blog
                </a>
              </li>
            </ul>
          </nav>

          {isLoggedIn ? (
            <>
              <Dropdown className="custom_dropdown profile_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  <img src={user.profile ? user.profile : userIcon} alt="user-profile" />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item as={Link} to="/profile-details">
                    <img src={profiledrop} alt="user-profile" />
                    Profile
                  </Dropdown.Item>
                  {/* <Dropdown.Item as={Link} to="/subscription">
                    <img src={crown_subscription} alt="" />
                    My Subscription
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/transaction">
                    <img src={delete_transaction} alt="" />
                    My Transaction
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    as="span"
                    to="/login"
                    onClick={() => setLogoutModal(true)}
                  >
                    <img src={logouticons} alt="icon" />
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </>
          ) : (
            // <div className="header_button_wrap">
            //   <img width={50} src={user.profile} alt="" />
            // </div>
            <div className="header_button_wrap">
              <Link
                to="/login"
                state={{ from: location.pathname }}
                className="button"
              >
                Login
              </Link>
              <Link to="/signup" className="button active">
                SignUp
              </Link>
            </div>
          )}
          <div
            className="hamburger_menu"
            onClick={() => setMobileMenu(!mobileMenu)}
          >
            {mobileMenu ? <FaTimes className="cross" /> : <GiHamburgerMenu />}
          </div>
        </div>
      </div>

      {/* Logout Modal */}
      <LogoutModal
        show={logoutModal}
        close={() => setLogoutModal(false)}
        logoutHandler={() => {
          setLogoutModal(false);
          logout();
        }}
      />
    </header>
  );
};

export default Header;
